import { render, staticRenderFns } from "./zhengwu.vue?vue&type=template&id=cd485a50&"
import script from "./zhengwu.vue?vue&type=script&lang=js&"
export * from "./zhengwu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports